
/*
 * @Author: liujia
 * @Date: 2022/11/15
 * @Desc: secondHeader 入口组件
 */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './secondHeader.scss';
import { Login } from 'gyyx-component-lib';
import { getShopCarTotalCount } from './service';
import { connect } from "react-redux";
import { theActionPageType } from '../../consts';
import { LocalstorageFn } from '../../utils/commonFn';//缓存数据
import { Menu } from 'antd';
//公用提示弹层
import TipPop from '../../components/TipPopBox';
const SecondHeader = (props) => {
    const { onOk } = props;

    const { loginStatus, setUpdateLogin,setCount,count } = props

    const [current, setCurrent] = useState('');

    // 显示登录弹窗
    const [modalVisible, setModalVisible] = useState(false);
    const [type, setType] = useState('');

    //显示公共弹层
    const [showtipflag, setShowtipflag] = useState(false);
    // 提示语
    const [msg, setMsg] = useState('');

    const getItems = () => {

        return [


            {
                label: (
                    <span>个人中心</span>
                ),
                key: 'SubMenu',
                children: [
                    {
                        type: 'myOrder',
                        label: <span>我的订单</span>,
                    },
                    {
                        type: 'getTool',
                        label: '领取游戏内道具',
                    },
                    {
                        type: 'changeTool',
                        label: '兑换游戏内道具',
                    },
                    {
                        type: 'cardTool',
                        label: '兑换卡查询',
                    },
                ],
            }
        ]
    }
    const myOrder = () => {
        setType('myBill');
        if (!loginStatus.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true })
        } else {
            window.location.href = '/myBill';
        }
    }
    const getTool = () => {
        setType('myBill');
        if (!loginStatus.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true })
        } else {
            window.location.href = '/getStageProperty';
        }
    }
    const changeTool = () => {
        setType('myBill');
        if (!loginStatus.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true })
        } else {
            window.location.href = '/exchangeItems';
        }
    }
    const cardTool = () => {
        setType('myBill');
        if (!loginStatus.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true })
        } else {
            window.location.href = '/cardQuery';
        }
    }
    //关闭登录弹层
    const onClose = () => {
        setModalVisible(false);
    }
    //登录成功回调
    const onSuccess = () => {
        if (type === 'myBill') {
            window.location.href = '/myBill';
        } else if (type === 'shoppingCart') {
            window.location.href = '/shoppingCart';
        }

    }

    // 我的购物车
    const myShoppingCart = () => {
        setType('shoppingCart');
        if (!loginStatus.isLogin) {
            setUpdateLogin({ isLogin: false, visibleLogin: true })
        } else {
            window.location.href = '/shoppingCart';
        }
    }

    useEffect(() => {
        getShopCarTotalCount({ from: theActionPageType }).then(
            res => {
                if (res.isSuccess) {
                    setCount(res.data?.shopCartTotal);
                    // 将数据存到本地缓存中
                    LocalstorageFn({
                        type: 'set',
                        key: 'deliveryCookieStr',
                        value: JSON.stringify(res.data?.orderFreight)
                    })
                }
            }
        )
    }, [])


    const onClick = (e) => {
        console.log('click ', e);
        setCurrent(e.key);
    };

    return (
        <div>
            <div className='topBar'>
                <div className='myContentBox'>


                    <span className="firstPage"><Link to={'/'}>首页</Link></span>
                    {/*<Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={getItems()} />*/}
                    <span className="userCenter">
                        <a onClick={myOrder}>个人中心</a>
                        <ul className='topBarDrop'>
                            <li onClick={myOrder}>我的订单</li>
                            <li onClick={getTool}>领取游戏内道具</li>
                            <li onClick={changeTool}>兑换游戏内道具</li>
                            <li onClick={cardTool}>兑换卡查询</li>
                        </ul>
                    </span>
                    <span onClick={myOrder}><a>我的订单</a></span>

                    <span onClick={myShoppingCart}><a>我的购物车(<span className='shopcartNumber'>{count}</span>)</a></span>



                </div>
            </div>
            {modalVisible && <Login onClose={onClose} onSuccess={onSuccess} />}
            {showtipflag && <TipPop
                title={msg}
                setChildShowtipflag={setShowtipflag}
            />}
        </div>
    )
}


const mapStateToProps = (state) => ({
    loginStatus:state.login.loginStatus,
    count:state.shopcar.count
});
const mapDispatchToProps = (dispatch) =>({
    setUpdateLogin:dispatch.login.setUpdateLogin,
    setCount:dispatch.shopcar.setCount
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondHeader)
